import { ReactNode } from 'react';
import { MarkerIcon, SMSIconFilled } from '@rsos/assets/icons';
import { formatInternationalPhoneNumberHuman } from '@rsos/utils/internationalPhoneNumberUtils';
import ToastBanner from '../base/Toast/ToastBanner';
import styles from './InboundReplyToast.module.css';

export type InboundReplyVariant = 'text' | 'location';

export interface InboundReplyToastProps {
  callerID: string;
  variant: InboundReplyVariant;
  onOpen: () => void;
}

const icons: Record<InboundReplyVariant, ReactNode> = {
  text: <SMSIconFilled data-name="inbound-reply-toast-icon" />,
  location: <MarkerIcon data-name="inbound-reply-toast-icon" />,
};

const messages: Record<InboundReplyVariant, string> = {
  text: 'New text message from',
  location: 'Location received from',
};

const InboundReplyToast = ({
  callerID,
  variant,
  onOpen,
}: InboundReplyToastProps) => {
  return (
    <ToastBanner
      dataName="inbound-reply-toast"
      icon={icons[variant]}
      buttonText="View"
      buttonDataName="inbound-reply-toast-view-button"
      onAction={onOpen}
    >
      <span className={styles.message} data-name="inbound-reply-toast-message">
        {messages[variant]} {formatInternationalPhoneNumberHuman(callerID)}
      </span>
    </ToastBanner>
  );
};

export default InboundReplyToast;
